import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
    FaArrowRight, FaUserTie, FaUsers, FaBook, FaUserMd,
    FaGraduationCap, FaMicroscope, FaAward, FaCalculator,
    FaGlobe, FaBullhorn, FaBriefcase, FaUserGraduate,
    FaLaptopCode, FaSearch, FaHistory, FaDraftingCompass,
    FaRunning, FaBrain, FaBalanceScale, FaCogs, FaUsersCog,
    FaFileAlt, FaChartLine, FaUniversity, FaStethoscope, FaFlask
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Departments.module.css";
import { testUrl } from "../home/BaseData";

const Department = () => {
    const { t, i18n } = useTranslation();
    const [rectors, setRectors] = useState([]);

    useEffect(() => {
        axios
            .get(testUrl + "/api/rectors/")
            .then((response) => {
                setRectors(response.data);
            })
            .catch((error) => console.error("Error fetching rectors data: ", error));
    }, [i18n.language]);

    const getIcon = (name) => {
        const n = name.toLowerCase();
        if (n.includes("xodim")) return <FaUsersCog />;
        if (n.includes("arxiv") || n.includes("monitoring")) return <FaFileAlt />;
        if (n.includes("yurist") || n.includes("kurashish")) return <FaBalanceScale />;
        if (n.includes("auditor")) return <FaSearch />;
        if (n.includes("matbuot")) return <FaBullhorn />;
        if (n.includes("kengash kotibi")) return <FaBriefcase />;
        if (n.includes("xalqaro")) return <FaGlobe />;
        if (n.includes("yoshlar") || n.includes("ma'naviyat")) return <FaBook />;
        if (n.includes("psixolog")) return <FaBrain />;
        if (n.includes("hamshira")) return <FaStethoscope />;
        if (n.includes("o'quv") || n.includes("boshqarma")) return <FaGraduationCap />;
        if (n.includes("marketing")) return <FaChartLine />;
        if (n.includes("laboratoriya")) return <FaFlask />;
        if (n.includes("innovatsiya") || n.includes("tadqiqot")) return <FaMicroscope />;
        if (n.includes("sifat")) return <FaAward />;
        if (n.includes("it") || n.includes("raqamli")) return <FaLaptopCode />;
        if (n.includes("buxgalteriya") || n.includes("moliya")) return <FaCalculator />;
        if (n.includes("xo'jalik")) return <FaHistory />;
        if (n.includes("muhandis")) return <FaCogs />;
        return <FaUniversity />;
    };

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.pageTitle}>{t("universityStructure") || "Universitet Tuzilmasi"}</h1>

            <div className={styles.structureList}>
                {rectors.map((rector, index) => (
                    <div key={rector.id || index} className={styles.sectionContainer}>
                        <div className={styles.flexLayout}>
                            {/* Left Side Side-Box */}
                            <Link to={`/employee/${rector.employee?.id}`} className={styles.sideBox}>
                                <div className={styles.sideIcon}>
                                    <FaUniversity />
                                </div>
                                <h3 className={styles.sideTitle}>
                                    {i18n.language === 'uz' ? rector.position_uz :
                                        i18n.language === 'ru' ? rector.position_ru || rector.position_uz :
                                            rector.position_en || rector.position_uz}
                                </h3>
                            </Link>

                            {/* Right Side Info & Grid */}
                            <div className={styles.contentArea}>
                                <div className={styles.itemsGrid}>
                                    {rector.departments && rector.departments.map((dept, idx) => {
                                        const link = `/centers/${dept.short_id}`;
                                        return (
                                            <Link
                                                key={dept.id || idx}
                                                to={link}
                                                className={styles.itemCard}
                                            >
                                                <div className={styles.itemIcon}>{getIcon(dept.name_uz)}</div>
                                                <div className={styles.itemText}>
                                                    <h4>
                                                        {i18n.language === 'uz' ? dept.name_uz :
                                                            i18n.language === 'ru' ? dept.name_ru || dept.name_uz :
                                                                dept.name_en || dept.name_uz}
                                                    </h4>
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Department;
